import React from 'react';
// if you need add new icon, consult https://material-ui.com/pt/components/material-icons/ then import from material-ui and add case
import {
  Settings,
  Search,
  SupervisorAccount,
  Assignment,
  Slideshow,
  Home,
  Link,
  DateRange,
  Dashboard,
  MoreHoriz,
  ChevronLeft,
  ChevronRight,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

const Icon = ({ name, ...props }) => {
  switch (name) {
    case 'settings':
      return <Settings {...props} />;

    case 'search':
      return <Search {...props} />;

    case 'admin':
      return <SupervisorAccount {...props} />;

    case 'task':
      return <Assignment {...props} />;

    case 'brief':
      return <Slideshow {...props} />;

    case 'home':
      return <Home {...props} />;

    case 'link':
      return <Link {...props} />;

    case 'calendar':
      return <DateRange {...props} />;

    case 'dashboard':
      return <Dashboard {...props} />;

    case '...':
      return <MoreHoriz {...props} />;

    case '<':
      return <ChevronLeft {...props} />;

    case '>':
      return <ChevronRight {...props} />;

    default:
      return null;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
